import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import AchievementMark from '../Achievements/AchievementMark';
import {
    achievementDisplayTitle,
    achievementFamily,
} from '../Achievements/achievementVisual';
import ShareOptionsModalV2 from '../../Share/ShareOptionsModalV2/ShareOptionsModalV2';
import './BadgeEarnedModal.css';

export function achievementIconType(item) {
    return achievementFamily(item);
}

/**
 * V2 celebration when a badge/milestone/streak is newly earned.
 * Same Customer APIs as classic ModalBadget. Does not modify V1.
 */
const BadgeEarnedModal = ({
    badge,
    goalsCompleted = 0,
    busy = false,
    onDismiss,
    onView,
}) => {
    const [shareOpen, setShareOpen] = useState(false);

    useEffect(() => {
        setShareOpen(false);
    }, [badge]);

    useEffect(() => {
        if (!badge) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape' && !busy && !shareOpen) onDismiss();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [badge, busy, onDismiss, shareOpen]);

    if (!badge) return null;

    const title = achievementDisplayTitle(badge);
    const canShare = Boolean(
        badge.socialMediaImageUrl || badge.socialMediaMessage
    );

    const handleView = () => {
        if (typeof onView === 'function') onView(badge);
        else onDismiss();
    };

    return ReactDOM.createPortal(
        <div>
            <div
                className="dv2-unlock"
                role="presentation"
                onClick={busy ? undefined : onDismiss}
            >
                <div
                    className="dv2-unlock__panel"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="dv2-unlock-title"
                    onClick={(e) => e.stopPropagation()}
                >
                    <span className="dv2-unlock__sparks" aria-hidden>
                        <i />
                        <i />
                        <i />
                        <i />
                        <i />
                        <i />
                    </span>
                    <p className="dv2-unlock__kicker">Achievement unlocked</p>
                    <div className="dv2-unlock__mark">
                        <span className="dv2-unlock__halo" aria-hidden />
                        <AchievementMark
                            item={badge}
                            tabHint={achievementFamily(badge)}
                            goalsCompleted={
                                badge.achievementValue || goalsCompleted || 0
                            }
                            size={148}
                            earned
                        />
                    </div>
                    <h3 id="dv2-unlock-title" className="dv2-unlock__title">
                        {title}
                    </h3>
                    {badge.congratsMessage ? (
                        <p className="dv2-unlock__msg">{badge.congratsMessage}</p>
                    ) : null}
                    <div className="dv2-unlock__actions">
                        <button
                            type="button"
                            className="dv2-unlock__btn dv2-unlock__btn--solid"
                            onClick={handleView}
                            disabled={busy}
                        >
                            {busy ? 'Saving…' : 'View achievement'}
                        </button>
                        {canShare ? (
                            <button
                                type="button"
                                className="dv2-unlock__btn dv2-unlock__btn--ghost"
                                onClick={() => setShareOpen(true)}
                                disabled={busy}
                            >
                                Share
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="dv2-unlock__btn dv2-unlock__btn--ghost"
                                onClick={onDismiss}
                                disabled={busy}
                            >
                                Continue
                            </button>
                        )}
                    </div>
                </div>
            </div>
            {shareOpen ? (
                <ShareOptionsModalV2
                    webAlias={badge.webAlias}
                    setActiveShare={setShareOpen}
                    imageUrl={badge.socialMediaImageUrl}
                    text={badge.socialMediaMessage}
                />
            ) : null}
        </div>,
        document.body
    );
};

export default BadgeEarnedModal;
